//
//
//
//
//
//
//
//
//
//
//

import PageSidebar from "../components/page-sidebar.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SidebarLayout",
  components: {
    PageSidebar
  },
  computed: {
    routerViewKey() {
      return this.$route.fullPath;
    }
  }
});